// LRS v1.0 helpers

(function() {
  document.addEventListener('DOMContentLoaded', function() {

    // navigation helper
    // Some browsers fire blur event before click on subnav so links are unclickable
    // use focus/blur event handlers to defer removal of the active state
    const navLabels = document.querySelectorAll('#nav label');

    if (navLabels.length > 0) {
      navLabels.forEach(function(el) {
        el.addEventListener('focus', function(e) {
          e.target.className = 'selected';
        });
        el.addEventListener('blur', function(e) {
          setTimeout(function() {
            e.target.className = '';
          }, 250);
        });
      });
    }

    // product view image selector
    const productImageSelectors = document.querySelectorAll('.hook-product-carousel-image');
    const productFeatureImage = document.querySelector('#featureproductimage');

    if (productImageSelectors.length > 0) {
      productImageSelectors.forEach(function(el) {
        el.addEventListener('click', function(e) {
          e.preventDefault();

          const target = e.target.nodeName.toLowerCase() === 'img' ? e.target.parentElement.href : e.target.href;
          productFeatureImage.src = target;

          return false;
        });
      });
    }
    const productSelect = document.querySelector('#productSelect');

    // product form option selectors - only instantiate when product selector exists
    if (Shopify && Shopify.OptionSelectors && productSelect) {
      const productSkuDisplay = document.querySelector('#variantSku');
      const productPriceDisplay = document.querySelector('#variantPrice');
      const addToCartButton = document.querySelector('#AddToCart');
      const configurationMessage = document.querySelector('#ConfigurationMessage');
      const selectCallback = function(variant, selector) {
        if (variant) {
          if (variant.featured_image && Shopify.Image && productFeatureImage) {
            var newImage = variant.featured_image;
            Shopify.Image.switchImage(newImage, productFeatureImage);
          }

          if (productSkuDisplay) productSkuDisplay.innerHTML = variant.sku;

          if (productPriceDisplay) {
            if (variant.price < variant.compare_at_price) {
            // jQuery('#price-preview').html(Shopify.formatMoney(variant.price, "{{ shop.money_format }}") + " <del>" + Shopify.formatMoney(variant.compare_at_price, "{{ shop.money_format }}") + "</del>");
              productPriceDisplay.innerHTML = Shopify.formatMoney(variant.price, MONEY_FORMAT) + ' <del class="text-gray-400">' + Shopify.formatMoney(variant.compare_at_price, MONEY_FORMAT) + '</del>';
            } else {
              productPriceDisplay.innerHTML = Shopify.formatMoney(variant.price, MONEY_FORMAT);
            }
          }

          if (addToCartButton) {
            if (variant.available) {
              addToCartButton.setAttribute('style', 'display: inline-block');
              if (configurationMessage) {
                configurationMessage.setAttribute('style', 'display: none');
              }
            } else {
              addToCartButton.setAttribute('style', 'display: none');
              if (configurationMessage) {
                configurationMessage.setAttribute('style', 'display: block');
              }
            }
          }
        } else {
          if (addToCartButton) {
            addToCartButton.setAttribute('style', 'display: none');
            if (configurationMessage) {
              configurationMessage.setAttribute('style', 'display: block');
            }
          }
        }
      }

      new Shopify.OptionSelectors('productSelect', { product: PRODUCT_JSON, onVariantSelected: selectCallback, enableHistoryState: true });
    }

    // product form size pricing - update size category field based on field input
    const priceBySizeForm = document.querySelector('.priceBySize-form');

    if (priceBySizeForm) {
      const itemHeight = document.querySelector('#height');
      // HACKY - better to set explicitly with metafields?
      const isNameplate = !!document.querySelector('[name="properties[Text]"]');
      const isNumberplate = !!document.querySelector('[name="properties[Number]"]');

      itemHeight.addEventListener('change', function(e) {
        const sizeEntered = parseFloat(e.target.value);

        const sizeCategory = document.querySelector('select[data-option="option1"]');
        const getCategory = function(sizeEntered, settings) {
          const max = settings.reduce(function(a, b) {
            const aa = typeof a === 'number' ? a : a.category;
            const bb = typeof b === 'number' ? b : b.category;
            return Math.max(aa, bb);
          });

          const select = settings.find(function(x) {
            return sizeEntered <= x.maxSize;
          });
          return select ? select.category : max + 1;
        }

        let categorySelect;

        if (!isNaN(sizeEntered)) {
          if (isNameplate && nameplateSizeBands) {
            categorySelect = getCategory(sizeEntered, nameplateSizeBands);
          }
          if (isNumberplate && numberplateSizeBands) {
            categorySelect = getCategory(sizeEntered, numberplateSizeBands);
          }

          if (categorySelect === undefined) {
            console.warn('Could not determine price band category');
          };

          if (sizeCategory.selectedIndex !== categorySelect) {
            sizeCategory.selectedIndex = categorySelect;

            const event = new Event('change');
            sizeCategory.dispatchEvent(event);
          }
        }
      });
    }

    // plate preview instantiation
    if (window.initFoundry !== undefined) {
      console.log('Foundry available');
      if (PRODUCT_STYLE && PRODUCT_FONTPATH) {
        initFoundry({
          style: PRODUCT_STYLE,
          fontPath: PRODUCT_FONTPATH,
          customisations: plateProperties,
          options: PRODUCT_JSON.options,
          variants: PRODUCT_JSON.variants,
        });
      } else {
        console.log('missing initialisation values for Foundry');
      }
    }
  });
})();
